import { STATUS_LABEL } from '@/lib/inzet'
import type { InzetStatus } from '@/lib/medewerker-types'
import { cn } from '@/lib/utils'

const DOT: Record<InzetStatus, string> = {
  overbezet: 'bg-status-overbezet',
  onderbezet: 'bg-status-onderbezet',
  in_orde: 'bg-status-in-orde',
  aanstelling_onbekend: 'bg-status-onbekend',
}

interface StatusDotProps {
  status: InzetStatus
  label?: boolean
  className?: string
}

export function StatusDot({ status, label = false, className }: StatusDotProps) {
  const punt = <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', DOT[status])} />

  if (!label) {
    return (
      <span className={cn('inline-flex items-center', className)}>
        {punt}
        <span className="sr-only">{STATUS_LABEL[status]}</span>
      </span>
    )
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md bg-fill-1 px-2 py-0.5 text-xs font-medium text-ink-soft ring-1 ring-inset ring-hairline',
        className,
      )}
    >
      {punt}
      {STATUS_LABEL[status]}
    </span>
  )
}
